<template>
    <div style="overflow-x:hidden">
        <BannerStatic :ban="wWidth<768?banner[1]:banner[0]" @scroll-job="handleScrollToJob"></BannerStatic>
        
        <People class="px-xs-32" ref="peopleRef"></People>
    </div>
</template>

<script>
import BannerStatic from '@/components/header/bannerStatic.vue'
import People from '@/components/people/people.vue'
export default {
    components:{
        BannerStatic,
        People
    },
    data(){
        return{
            banner: [require('@/assets/employ/new-6.jpg'),require('@/assets/phone/bannerCO.png')],
            wWidth: window.screen.width
        }
    },
    methods: {
        handleScrollToJob() {
            // 调用People组件内部滚动函数
            this.$refs.peopleRef.scrollToJob()
        }
    }
}
</script>